import { request } from '@/api/index';
export function getStrucList(data) {
  return request({
    url: '/api/Common/GetStrucList',
    method: 'get',
    params: data
  });
}
export function getStaffs(data) {
  return request({
    url: '/api/Common/getStaffs',
    method: 'get',
    params: data
  });
}
export function getBTypeList(data) {
  return request({
    url: '/api/Common/GetBTypeList',
    method: 'get',
    params: data
  });
}